import React, { Component } from 'react';
import SelectUser from 'nbugs-address-select-user';
import { Spin } from 'antd';
import { connect } from 'dva';
// import BreadNav from '../../../../components/BreadNav/BreadNav';
// import { getCurrentBreadCrumbs } from '@/utils/utils';
import Container from '../../../../../components/Container';
import PersonDetails from '../../AddressList/components/PersonDetails';
import Teacher from './Teacher/index';
import styles from './index.less';

@connect(({ countyPersonnel, loading }) => {
  return {
    loading: loading.effects['countyPersonnel/fetchDeptTypeList'],
    ...countyPersonnel,
  };
})
class Personnel extends Component {
  constructor(props) {
    super(props);

    // const { search } = window.location;

    // this.state = {
    //   breadcrumb: getCurrentBreadCrumbs({
    //     currentUrl: {
    //       context: '人员管理',
    //       path: `/countyContacts/personnel${search}`,
    //     },
    //     isTop: true,
    //     storekey: 'countyManagementCenterBreadcrumb',
    //   }),
    // };

    this.renderTablePage = this.renderTablePage.bind(this);
    this.handleSetSelectedDeptVisible = this.handleSetSelectedDeptVisible.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handlePersonDetailsCancel = this.handlePersonDetailsCancel.bind(this);
    this.handleUserClick = this.handleUserClick.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'countyPersonnel/fetchDeptTypeList',
    });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'countyPersonnel/reset',
    });
  }

  // 修改选人组件的状态;
  handleSetSelectedDeptVisible(status) {
    const { dispatch } = this.props;

    dispatch({
      type: 'countyPersonnel/save',
      payload: { showSelectUserModal: status },
    });
  }

  // 批量加入部门
  handleConfirm({ checkedNodes = [] } = {}) {
    const { selectedRowKeys, dispatch } = this.props;

    const deptIds = checkedNodes.map(({ deptId }) => deptId);
    dispatch({
      type: 'countyPersonnel/batchAddDept',
      searchParams: { deptIds, userIds: selectedRowKeys },
    });
  }

  // 取消显示用户modal
  handlePersonDetailsCancel() {
    const { dispatch } = this.props;
    dispatch({
      type: 'countyPersonnel/save',
      payload: { showUserDetailsModal: false },
    });
  }

  // 点击用户 弹出用户信息modal
  handleUserClick(userId) {
    const { dispatch } = this.props;

    dispatch({
      type: 'countyPersonnel/fetchUserDetils',
      params: { userId },
    });
  }

  renderTablePage() {
    const props = {
      handleSetSelectedDeptVisible: this.handleSetSelectedDeptVisible,
      handleUserClick: this.handleUserClick,
    };

    return <Teacher {...props} />;
  }

  render() {
    const { spinProps, showSelectUserModal, showUserDetailsModal, userDetails } = this.props;

    // const { breadcrumb } = this.state;
    return (
      <Container breStates={!0} version={2} defaultPadding>
        <div className={styles.root}>
          <Spin {...spinProps}>
            {/* <BreadNav key="breadNav" dataSource={breadcrumb} /> */}

            <div className="content-container">
              <div className="content-container-body">
                {this.renderTablePage()}
                {showSelectUserModal && (
                  <SelectUser
                    selectType="dept"
                    showComp
                    onCancel={this.handleSetSelectedDeptVisible}
                    onOk={this.handleConfirm}
                  />
                )}
                {!!showUserDetailsModal && (
                  <PersonDetails
                    show
                    userDetails={userDetails}
                    spinning={false}
                    isRenderFooter={1}
                    handleCancel={this.handlePersonDetailsCancel}
                  />
                )}
              </div>
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Personnel;
